export var createUriForEditor = function createUriForEditor(monaco, editorName) {
  return monaco.Uri.parse("inmemory://".concat(editorName));
};
var isModelForEditor = function isModelForEditor(model, editorName) {
  return model.uri.authority === editorName;
};
export default isModelForEditor;